import React from 'react';
import { Sparkles, X } from 'lucide-react';

export const ChatHeader = ({ onClose }) => (
  <div className="flex items-center justify-between px-5 py-4 border-b border-[#D4AF37]/20 bg-gradient-to-r from-black to-[#1A0B0C]">
    <div className="flex items-center gap-3">
      <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#F3E5AB] to-[#AA8022] flex items-center justify-center">
        <Sparkles className="w-4 h-4 text-black" strokeWidth={2} />
      </div>
      <div>
        <div className="text-white font-['Cormorant_Garamond'] text-base font-medium leading-none">
          Nitika&apos;s Assistant
        </div>
        <div className="text-[10px] uppercase tracking-[0.2em] text-[#D4AF37] mt-1">
          Book a Reading
        </div>
      </div>
    </div>
    <button
      type="button"
      onClick={onClose}
      className="text-white/60 hover:text-white transition-colors"
      aria-label="Close chat"
      data-testid="chat-close-btn"
    >
      <X className="w-5 h-5" />
    </button>
  </div>
);
